// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"ddbd1e6d","453":"ed77585c","879":"c0a8dc01"}[chunkId] + ".chunk.js";
};